<template>
  <div />
</template>

<script>
import { mapActions, mapGetters } from 'vuex'



export default {
  name: 'OidcCallback',
  computed: {
    ...mapGetters('oidcStore', [
      'oidcIsAuthenticated',
      'oidcUser',
      'oidcAccessToken'
    ]),
  },
  created () {
    this.oidcSignInCallback()
            .then((redirectPath) => {
              this.$router.push(redirectPath)
            })
            .catch((err) => {
              // dirty hack for firefox private window mode
              if(err.message === 'No matching state found in storage') {
                this.authenticateOidc()
                return
              }
              this.$router.push('/signin-oidc-error') // Handle errors any way you want
            })
  },
  methods: {
    ...mapActions('oidcStore', [
      'oidcSignInCallback',
      'authenticateOidc'
    ])
  }
}
</script>
